import { NgModule } from '@angular/core';
import { JssModule } from '@sitecore-jss/sitecore-jss-angular';
import { QuickLinkComponent } from './quick-link.component';
import { AppComponentsSharedModule } from '../app-components.shared.module';
@NgModule({
  imports: [
    JssModule.forChild(QuickLinkComponent),
    AppComponentsSharedModule,
  ],
  // declarations: [
  //   QuickLinkComponent
  // ],
})
export class QuickLinkModule { }
